<template>
  <div id="info" >
    <div class="main">
      <div class="pointOut" >必填</div>
      <div class="avatar" style="position: relative">
        <span v-if="type != 'member'" >头像</span>
        <span v-if="type == 'member'" >会员单位Logo</span>
        <div class="avatar-img" >
          <img v-if="profileImg" :src="profileImg" alt="">
          <img v-if="!profileImg" src="@/assets/images/Mensingles.png">
          <div class="profile-loading" v-show="profileLod" >
            <van-loading type="spinner" />
          </div>
          <!-- :disabled="isClubRead" -->
          <van-uploader class="uploader" :after-read="onRead" >
            <van-icon name="photograph" />
          </van-uploader>
        </div>
        <div v-if="type != 'member'" style="position: absolute;left: 10px;color: red;font-size: 12px;bottom: 4px">
          注：请务必上传标准证件照，以免影响到您的会员资格审核<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;照片需及时更新，近半年内有效期为宜
        </div>
      </div>
      <van-cell-group
        class="cell-list"
        v-if="type != 'member'" >
        <van-field
          v-model="info.trueName"
          :error-message="validator.ErrMsg.trueName"
          :disabled="isRead"
          label="姓名"
          placeholder="请输入真实姓名"
          input-align="right"
          error-message-align="right" >
        </van-field>
        <van-radio-group
          v-model="info.nationality" :disabled="isRead">
          <van-cell-group>
            <van-cell title="国籍" clickable>
              <van-radio checked-color="#185494" name="中国" >中国</van-radio>
              <van-radio checked-color="#185494" name="其他" >其他</van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-radio-group
          v-model="info.certificateType" :disabled="isRead">
          <van-cell-group>
            <van-cell title="证件类型" clickable>
              <van-radio checked-color="#185494" name="身份证" >身份证</van-radio>
              <van-radio checked-color="#185494" name="护照" >护照</van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-field
          v-model="info.certificateNum"
          type="text"
          :error-message="validator.ErrMsg.certificateNum"
          :disabled="isRead || info.certificateType==0"
          label="证件号码"
          placeholder="请输入证件号"
          @blur="checkCertNum"
          input-align="right">
        </van-field>
        <van-radio-group
                v-model="info.gender" :disabled="isRead || info.certificateType==='身份证'">
          <van-cell-group>
            <van-cell title="性别" clickable>
              <van-radio checked-color="#185494" name="男" >男</van-radio>
              <van-radio checked-color="#185494" name="女" >女</van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-field
                @click="setPicker('birthday')"
                :error-message="validator.ErrMsg.birthday"
                v-model="info.birthday"
                label="出生日期"
                placeholder="请选择"
                readonly
                :disabled="isRead"
                input-align="right"
                error-message-align="right">
        </van-field>

        <van-cell
          @click="uploadCert(1)"
          title="上传证件"
          is-link>
        </van-cell>
      </van-cell-group>

      <!-- 运动员 -->
      <van-cell-group
        class="cell-list"
        v-if="type === 'player'" >
        <van-field
          @click="setPicker('category')"
          :error-message="validator.ErrMsg.category"
          v-model="info.category"
          label="身份类型" placeholder="请选择身份类型"
          readonly
          input-align="right">
        </van-field>
        <van-field
          v-if="info.category === '北京学生'"
          @click="setPicker('school')"
          readonly
          :error-message="validator.ErrMsg.school"
          v-model="info.school.name" label="就读学校"
          placeholder="就读学校"
          input-align="right">
        </van-field>
        <van-cell
          v-if="info.category === '北京学生'"
          title="上传学籍卡"
          is-link
          @click="uploadCert(2)">
        </van-cell>
        <van-field
          v-if="info.category !== '成人' && info.category !== '学龄前儿童'"
          @click="setPicker('enterSchoolYear')"
          :error-message="validator.ErrMsg.enterSchoolYear"
          v-model="info.enterSchoolYear"
          label="入学年度"
          placeholder="请选择年度"
          input-align="right">
        </van-field>
        <div class="pointOut" >选填</div>
        <van-field
          v-if="false"
          class="cell-width"
          :value="firstRegisterYear"
          readonly
          disabled
          label="首次注册年度"
          input-align="right">
        </van-field>
        <van-field
          v-if="false"
          class="cell-width"
          :value="validMemberShip.year"
          disabled
          readonly label="再次注册年度"
          input-align="right">
        </van-field>
        <van-field
          class="cell-width"
          :value="area"
          disabled
          readonly label="注册地"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.high"
          label="身高"
          placeholder="cm"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.weight"
          label="体重" placeholder="kg"
          input-align="right">
        </van-field>
        <van-radio-group
          v-model="info.stickHand">
          <van-cell-group>
            <van-cell title="持杆方式" clickable>
              <van-radio checked-color="#185494" name="左手杆" >左手杆</van-radio>
              <van-radio checked-color="#185494" name="右手杆" >右手杆</van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-radio-group
          v-model="info.isAbroad">
          <van-cell-group>
            <van-cell title="是否出国" clickable>
              <van-radio checked-color="#185494" :name="0" >否</van-radio>
              <van-radio checked-color="#185494" :name="1" >是</van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-field
          v-if="info.isAbroad === 1"
          @click="setPicker('abroadDate')"
          v-model="info.abroadDate"
          label="出国日期"
          placeholder="请选择"
          readonly
          input-align="right"
          error-message-align="right">
        </van-field>
        <div class="textarea">
          <h5>教育背景</h5>
          <textarea
            v-model="info.educationSummary"
            placeholder="请输入文字内容"
            name=""
            id=""
            cols="20"
            rows="5">
          </textarea>
        </div>
      </van-cell-group>

      <!-- 教练员 -->
      <van-cell-group
        class="cell-list"
        v-if="type === 'coach'" >
        <div class="pointOut" >选填</div>
        <van-field
          v-if="false"
          class="cell-width"
          :value="firstRegisterYear"
          readonly
          disabled
          label="首次注册年度"
          input-align="right">
        </van-field>
        <van-field
          v-if="false"
          class="cell-width"
          :value="validMemberShip.year"
          readonly
          disabled
          label="再次注册年度"
          input-align="right">
        </van-field>
        <van-field
          class="cell-width"
          :value="area"
          readonly
          disabled
          label="注册地"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.high"
          label="身高"
          placeholder="cm"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.weight"
          label="体重"
          placeholder="kg"
          input-align="right">
        </van-field>
        <van-field
          @click="setPicker('educationLevel')"
          v-model="info.educationLevel"
          label="文化程度" placeholder="请选择"
          readonly
          input-align="right">
        </van-field>
        <van-field
          @click="setPicker('foreignLanguage')"
          v-model="info.foreignLanguage"
          label="外语种类"
          placeholder="请选择类型"
          readonly
          input-align="right">
        </van-field>
      </van-cell-group>

      <!-- 裁判 -->
      <van-cell-group class="cell-list" v-if="type === 'in-referee' || type === 'out-referee'" >
        <van-radio-group
          v-model="info.inField"
          readonly>
          <van-cell-group>
            <van-cell  title="是否场内" clickable>
              <van-radio checked-color="#185494" name="是" >是</van-radio>
              <van-radio checked-color="#185494" name="否" >否</van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <div class="pointOut" >选填</div>
        <van-field
          v-model="info.high"
          label="身高"
          placeholder="cm"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.weight"
          label="体重"
          placeholder="kg"
          input-align="right">
        </van-field>
        <van-field
          @click="setPicker('educationLevel')"
          v-model="info.educationLevel"
          label="文化程度"
          placeholder="请选择证件类型"
          readonly
          input-align="right">
        </van-field>
        <van-field
          @click="setPicker('foreignLanguage')"
          v-model="info.foreignLanguage"
          label="外语种类"
          placeholder="请选择"
          readonly
          input-align="right">
        </van-field>
        <!--<van-field-->
          <!--@click="setPicker('instructorLevel')"-->
          <!--v-model="info.instructorLevel"-->
          <!--label="指导员级别"-->
          <!--placeholder="请选择"-->
          <!--readonly-->
          <!--input-align="right">-->
        <!--</van-field>-->
        <!--<van-field-->
          <!--@click="setPicker('refereeLevel')"-->
          <!--v-model="info.refereeLevel"-->
          <!--label="裁判等级"-->
          <!--placeholder="请选择"-->
          <!--readonly-->
          <!--input-align="right">-->
        <!--</van-field>-->
        <van-field
          v-model="info.instructorLevel"
          label="指导员级别"
          placeholder="指导员级别"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.refereeLevel"
          label="裁判等级"
          placeholder="裁判等级"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.refereeCertificateNo"
          label="裁判证号"
          placeholder="请输入证号"
          input-align="right">
        </van-field>
        <van-field
          @click="setPicker('refereeCertificateDate')"
          v-model="info.refereeCertificateDate"
          label="批准日期"
          placeholder="请选择日期"
          readonly
          input-align="right">
        </van-field>
        <van-field
          v-model="info.employerOrganization"
          label="工作单位"
          placeholder="请输入单位名称"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.workplaceAddress"
          label="工作单位地址"
          placeholder="请输入单位地址"
          input-align="right">
        </van-field>
      </van-cell-group>

      <!-- 会员 -->
      <van-cell-group class="cell-list" v-if="type === 'member'" >
        <van-field
          v-model="info.name"
          label="会员单位名称"
          :error-message="validator.ErrMsg.name"
          placeholder="与提交营业执照单位名称一致"
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <van-field
          @click="setPicker('establishDate')"
          :error-message="validator.ErrMsg.establishDate"
          v-model="info.establishDate"
          label="成立时间"
          placeholder="请选择日期"
          readonly
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <van-cell
          title="资质证明图片"
          is-link
          @click="uploadCert(3)">
        </van-cell>
        <van-field
          v-model="info.email"
          type="text" label="电子邮箱"
          placeholder="请输入电子邮箱"
          input-align="right"
          :disabled="isClubRead"
          :error-message="validator.ErrMsg.email">
        </van-field>
        <van-field
          v-model="info.contact"
          :error-message="validator.ErrMsg.contact"
          label="联系人"
          placeholder="姓名"
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.mobile"
          :error-message="validator.ErrMsg.mobile"
          label="联系人电话"
          placeholder="电话"
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.address"
          :error-message="validator.ErrMsg.address"
          label="联系地址"
          placeholder="地址"
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <div class="pointOut" >选填</div>
        <van-field
          v-if="false"
          class="cell-width"
          :value="firstRegisterYear"
          readonly
          label="首次注册年度"
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <van-field
          v-if="false"
          class="cell-width"
          :value="validMemberShip.year"
          readonly
          label="再次注册年度"
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.teams"
          label="俱乐部名称"
          placeholder="多个俱乐部以', '分隔"
          :disabled="isClubRead"
          input-align="right">
        </van-field>

        <van-field
          v-model="info.humanCount"
          label="职工总数"
          placeholder=""
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.assertCount"
          label="资产总额（亿）"
          placeholder="¥"
          :disabled="isClubRead"
          input-align="right">
        </van-field>
        <van-field
          v-model="info.inComeCount"
          label="年度营业收入总额（亿）"
          placeholder="¥"
          :disabled="isClubRead"
          input-align="right">
        </van-field>
      </van-cell-group>

      <van-field
        @click="setPicker('source')"
        :error-message="validator.ErrMsg.source"
        v-model="info.source"
        label="请选择渠道" placeholder="请选择"
        readonly
        :disabled="isClubRead"
        input-align="right">
      </van-field>

      <div class="textarea" v-if="info.source==sourceList[3]">
        <h5>其他渠道</h5>
        <textarea
          v-model="info.otherSource"
          :disabled="isClubRead"
          placeholder="请输入"
          name=""
          cols="20"
          rows="2">
          </textarea>
      </div>

      <div>
        <van-button v-if="!isRead || isAppend" size="large" @click="registerSubmit()" class="submit" :disabled="loading">{{type=='member'?'完成':'下一步'}}</van-button>
        <van-button v-if="isRead && !isAppend" size="large" @click="updateInfo()" class="submit" >保存</van-button>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :overlay="true">
      <div v-show="popType == 'school'">
        <van-field
          v-model="schoolSearch"
          label="搜索学校"
          placeholder="请输入关键字"
          input-align="right">
            <van-button slot="button" size="small" type="default" @click="onSchoolSearch">搜索</van-button>
        </van-field>
      </div>
      <van-picker show-toolbar :columns="columns" value-key="name" @change="onChange" @cancel="onCancel" @confirm="onConfirm" ></van-picker>
    </van-popup>
    <!-- 日期 -->
    <van-popup v-model="PopupDate" position="bottom" :overlay="true">
      <van-datetime-picker
        v-model="currentDate"
        :type="dateType"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="dateFormatter"
        @confirm="dateConfirm"
        @cancel="dateCancel"
        :item-height="55"
      >
      </van-datetime-picker>
    </van-popup>
    <!-- 语言 -->
    <van-popup v-model="popupLang" position="bottom" :overlay="true">
      <van-picker show-toolbar @confirm="languageConfirm" @cancel="languageCancel" @change="onLangChange" :columns="langColumns" ></van-picker>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import _ from 'lodash'
import axios from 'axios'
import ValidatorUtils from '@/libs/validator'
import { checkPassport } from '@/libs/passport'
import { getValidMembership, ImageFormat, ConstConfig, documentVerification, getBirthdayFromIdCard } from '@/utils'
import { setRegisterInfo, getRegisterInfo, getMemberType, getMembership, removeMemberType,
  removeRegisterInfo } from '@/libs/cookie-storage'
import { registOrganization, getSchoolList, getRegReferee, getRegCoach, getRegPlayer, getRegOrganization,
  getMyReferee, getMyCoach, getMyPlayer, getMyOrganization, updatePlayer, updateCoach, updateReferee,
  updateOrganization, getSourceList, checkID } from '@/api/info'
import { getQiniuUploadToken } from '@/api/user'

import { Field, Uploader, Icon, Popup, Picker, DatetimePicker, Cell, CellGroup, Button, Toast, RadioGroup, Radio, Loading } from 'vant'
Vue.use(Field).use(Uploader).use(Icon).use(Popup).use(Picker).use(DatetimePicker).use(Cell).use(CellGroup).use(Button).use(Toast, RadioGroup, Radio, Loading)

const rulesField = {
  player: ['profile', 'source', 'trueName', 'gender', 'nationality', 'birthday', 'certificateType', 'certificateNum', 'certificateFrontImg', 'certificateBackImg', 'category'],
  coach: ['profile', 'source', 'trueName', 'gender', 'nationality', 'birthday', 'certificateType', 'certificateNum', 'certificateFrontImg', 'certificateBackImg'],
  'in-referee': ['profile', 'trueName', 'gender', 'nationality', 'birthday', 'certificateType', 'certificateNum', 'certificateFrontImg', 'certificateBackImg', 'inField'],
  'out-referee': ['profile', 'trueName', 'gender', 'nationality', 'birthday', 'certificateType', 'certificateNum', 'certificateFrontImg', 'certificateBackImg', 'inField'],
  member: ['profile', 'source', 'email', 'name', 'establishDate', 'certificateImg', 'contact', 'mobile', 'address']
}
export default {
  name: 'PersonalInformation',
  data() {
    return {
      profileLod: false,
      schoolSearch: '',
      qiniuToken: '',
      schoolList: [],
      enterYearList: [],
      popType: '',
      dateType: 'date',
      type: null, // player => 运动员, coach => 教练, referee => 裁判, member => 会员
      PopupDate: false,
      minDate: new Date(1900, 1, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      columns: [],
      langColumns: [],
      show: false,
      popupLang: false,
      validator: {
        ErrMsg: {}
      },
      info: {
        certificateFrontImg: '',
        certificateBackImg: '',
        studentCardImg: '',
        certificateImg: '',
        profile: '',
        gender: '',
        nationality: '',
        certificateType: '',
        stickHand: '',
        school: {},
        isAbroad: 0,
        abroadDate: ''
      },
      isRead: false,
      firstRegisterYear: '',
      area: '北京-长期',
      validMemberShip: {},
      rules: {
        profile: [{ required: true, message: '必填消息' }],
        trueName: [{ required: true, message: '必填消息' }],
        gender: [{ required: true, message: '必填消息' }],
        nationality: [{ required: true, message: '必填消息' }],
        birthday: [{ required: true, message: '必填消息' }],
        certificateType: [{ required: true, message: '必填消息' }],
        source: [{ required: true, message: '必填消息' }],
        certificateNum: [
          { required: true, message: '必填消息' },
          { validator: (rule, value, callBack) => {
            const idVerify = documentVerification(value)
            if (this.info.certificateType === '身份证' && idVerify.pass) {
              callBack()
            } else if (this.info.certificateType === '护照') {
              callBack()
            } else {
              callBack(idVerify.msg)
            }
          }
          }
        ],
        category: [{ required: true, message: '必填消息' }],
        school: [{ required: true, message: '必填消息' }],
        enterSchoolYear: [{ required: true, message: '必填消息' }],
        certificateFrontImg: [{ required: true, message: '必填消息' }],
        certificateBackImg: [{ required: true, message: '必填消息' }],
        studentCardImg: [{ required: true, message: '必填消息' }],
        inField: [{ required: true, message: '必填消息' }],
        name: [{ required: true, message: '必填消息' }],
        establishDate: [{ required: true, message: '必填消息' }],
        certificateImg: [{ required: true, message: '必填消息' }],
        contact: [{ required: true, message: '必填消息' }],
        mobile: [{ required: true, message: '必填消息' }],
        address: [{ required: true, message: '必填消息' }],
        email: [{ required: true, message: '必填消息' }]
      },
      reset: '',
      isAppend: false,
      isClubRead: false,
      loading: false,
      sourceList: []
    }
  },
  computed: {
    profileImg() {
      return ImageFormat.squareImageView(this.info.profile, 140, 2)
    }
  },
  created() {
    checkPassport()
    // 初始化先尝试获取本地存储
    this.sourceList = getSourceList()
    const memberType = getMemberType()
    if (!memberType) return
    this.type = memberType.type
    const regInfo = getRegisterInfo()
    // server 获取最新数据
    if (memberType.status === 2) {
      this.isRead = true
      this.getMyInfo()
    } else if (regInfo) { // 第一次注册先取缓存，防止页面关闭
      this.info = regInfo
      this.mapPickerValues()
      this.getSchoolList()
    } else {
      this.getRegInfo()
    }
    if (this.type === 'in-referee') {
      this.info.inField = '是'
    } else if (this.type === 'out-referee') {
      this.info.inField = '否'
    }
    const memberShip = getMembership()
    const firstRegister = _.find(memberShip.firstRegistLogs, function (item) {
      return item.membershipTypeId === memberType.membershipTypeId
    })
    this.validMemberShip = getValidMembership()
    if(this.validMemberShip.membership && this.validMemberShip.membership.length > 0) {
      const obj = _.find(this.validMemberShip.membership, function (item) {
        return item.membershipTypeId === memberType.membershipTypeId
      })
      this.isAppend = !obj // obj is undefined, so is append member type
      if (this.isAppend) {
        this.isRead = true
      }

      // const isInValid = moment().isAfter(this.validMemberShip.membershipBeginDate)
      const isCenter = this.$route.query.isCenter
      this.isClubRead = this.isRead && (isCenter == 1)
    }
    // 首次注册年份的显示
    if (!firstRegister) {
      this.firstRegisterYear = this.validMemberShip.year
    } else {
      this.firstRegisterYear = firstRegister.membershipYear
    }
    const currentYear = moment().format('YYYY')
    for (let i = 0; i < 20; i++) {
      this.enterYearList[i] = currentYear - (i - 1)
    }
    this.validator = new ValidatorUtils({
      rules: this.rules,
      data: this.info
    })
//    this.info = this.validator.Data
    this.reset = this.$route.query.reset
  },
  mounted() {
    this.getQiniuToken()
  },
  methods: {
    checkCertNum() {
      // this.validator.ErrMsg = {}
      if (!this.info.trueName) {
        Toast('姓名不能为空')
        return
      }
      if (!this.info.certificateNum) {
        return
      }
      if (this.info.certificateType === '身份证') {
        const certFormatValid = documentVerification(this.info.certificateNum)
        if (certFormatValid.pass) {
          // 阿里接口校验，成功则生成生日，失败则提示用户错误信息
          const params = {
            idNo: this.info.certificateNum,
            name: this.info.trueName
          }
          checkID(params).then((res) => {
            const data = res.data
            if (data && data.info) {
              // 自动填写生日
              this.info.birthday = getBirthdayFromIdCard(this.info.certificateNum)
              this.info.gender = data.info.gender
              this.$set(this.validator.ErrMsg, 'certificateNum', '')
            } else {
              // 错误提示
              this.$set(this.validator.ErrMsg, 'certificateNum', '身份证信息检查不通过')
            }
          })
        } else {
          this.$set(this.validator.ErrMsg, 'certificateNum', certFormatValid.msg)
        }
      } else {
        this.$set(this.validator.ErrMsg, 'certificateNum', '')
      }
    },
    registerSubmit() {
      let rulesObj = rulesField[this.type]
      debugger
      const self = this
      this.validator.validate(rulesObj).then(() => {
        if (this.type === 'member') {
          this.submitMember()
        }
        if (this.info.certificateType === '身份证') {
          // 实名认证校验
          const params = {
            idNo: this.info.certificateNum,
            name: this.info.trueName
          }
          checkID(params).then((res) => {
            const data = res.data
            if (data && data.info) { // 认证通过
              this.readyNextStep()
            } else {
              Toast('身份证信息检查不通过')
            }
          })
        } else {
          this.readyNextStep()
        }
      }, (rej) => {
        this.$set(this.info, rej.field)
        Toast('请填写必要的信息')
      })
    },
    readyNextStep() {
      const self = this
      Toast('已完成操作请前往下一步')
      // set into cookie
      setRegisterInfo(self.info)
      if (this.type === 'coach') {
        this.$router.push('personal-experience')
      } else if (this.type === 'player') {
        // 非成人检查学校和入学年度
        if (self.info.category === '北京学生') {
          if (!(this.info.school && this.info.enterSchoolYear && this.info.studentCardImg)) {
            Toast('北京学生需要填写就读学校、学籍卡、入学年度信息')
            return
          }
        } else if (self.info.category === '外地学生') {
          if (!this.info.enterSchoolYear) {
            Toast('外地学生需要填写入学年度信息')
            return
          }
        }
        // 校验出生日期是否大于4周岁
        const year = this.validMemberShip.year - 4
        const age = moment(self.info.birthday).diff(moment(year + '-12-31'), 'days')
        if (age > 0) {
          Toast('该运动员小于4周岁，不允许注册')
          return
        }
        const years = moment().diff(moment(self.info.birthday), 'year')
        if (years >= 18 && self.info.category != '成人') {
          Toast('该运动员已满18周岁，请选择身份类型为成人')
          return
        } else if (years < 18 && self.info.category == '成人') {
          Toast('该运动员未满18周岁，请选择其他身份类型')
          return
        }
        this.$router.push('hockey')
      } else if (this.type === 'in-referee' || this.type === 'out-referee') {
        this.$router.push('personal-experience')
      }
    },
    submitMember() {
      this.loading = true
      let params = {
        profile: this.info.profile,
        name: this.info.name,
        establishDate: moment(this.info.establishDate).format('YYYY-MM-DDTHH:mm:ss+0800'),
        certificateImg: this.info.certificateImg,
        email: this.info.email,
        contact: this.info.contact,
        mobile: this.info.mobile,
        address: this.info.address,
        teams: this.info.teams,
        humanCount: this.info.humanCount,
        assertCount: this.info.assertCount,
        inComeCount: this.info.inComeCount
      }
      if (this.info.source === this.sourceList[3]) {
        params.source = this.info.otherSource
      } else {
        params.source = this.info.source
      }
      if (this.info.id) {
        params.id = this.info.id
        updateOrganization(params).then((res) => {
          if (res) {
            Toast('完善信息成功')
            removeMemberType()
            removeRegisterInfo()
            this.$router.push('review')
            this.loading = false
          }
        }, (reject) => {
          Toast('完善信息失败')
          this.loading = false
        })
      } else {
        registOrganization(params).then((res) => {
          if (res) {
            Toast('完善信息成功')
            removeMemberType()
            removeRegisterInfo()
            this.$router.push('review')
            this.loading = false
          }
        }, (reject) => {
          Toast('完善信息失败')
          this.loading = false
        })
      }
    },
    onRead(file) {
      this.profileLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.info.profile = res.hash
          this.profileLod = false
        }
      })

    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      return new Promise((resolve, reject) => {
        axios.post(ConstConfig.qiniuUpload, formData, config).then( res => {
          const data = res.data
          resolve(data)
        }).catch( error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        Toast('七牛Token获取失败')
      })
    },
    getSchoolList(name) {
      const params = {
        name: name || ''
      }
      getSchoolList(params).then(response => {
        const data = response.data
        if(data) {
          this.schoolList = data.list
          if (this.info.schoolId) {
            const self = this
            this.info.school = _.find(data.list, function (item) {
              return item.id === self.info.schoolId
            })
          }
        } else {
          Toast('学校列表获取失败')
        }
      })
    },
    onSchoolSearch() {
      const params = {
        name: this.schoolSearch
      }
      getSchoolList(params).then(response => {
        const data = response.data
        if(data) {
          this.columns = data.list
        }
      })
    },
    setPicker(popType) {
      if (this.isRead && popType != 'stickHand' && popType != 'educationLevel' &&
        popType != 'foreignLanguage' && popType != 'instructorLevel' && popType != 'refereeLevel' &&
        popType != 'refereeCertificateDate' && popType != 'category' && popType != 'school' && popType != 'source' &&
        popType != 'establishDate' && popType != 'abroadDate')
          return
      this.popType = popType
      if (popType === 'gender') {
        this.columns = ['男', '女']
      } else if (popType === 'nationality') {
        this.columns = ['中国', '其他']
      } else if (popType === 'birthday') {
        if (this.info.certificateType === '身份证') {
          this.PopupDate = false
        } else {
          this.PopupDate = true
        }
        return
      } else if (popType === 'abroadDate') {
        this.PopupDate = true
        return
      } else if (popType === 'certificateType') {
        this.columns = ['身份证', '护照']
      } else if (popType === 'category') {
        this.columns = ['北京学生', '外地学生', '学龄前儿童', '成人']
      } if (popType === 'school') {
        this.columns = this.schoolList
      } else if (popType === 'enterSchoolYear') {
        this.columns = this.enterYearList
      } else if (popType === 'stickHand') {
        this.columns = ['左手杆', '右手杆']
      } else if (popType === 'educationLevel') {
        this.columns = ['小学', '初中', '高中', '专科', '本科', '硕士', '博士']
      } else if (popType === 'source') {
        this.columns = this.sourceList
      } else if (popType === 'foreignLanguage') {
        let langValues = ['汉语', '良好']
        if (this.info.foreignLanguage && this.info.foreignLanguage.indexOf('|') > -1) {
          langValues = this.info.foreignLanguage.split('|')

        }
        const langLevel = ['一般', '良好', '熟练', '精通']
        const lang = {
          '汉语': langLevel,
          '法语': langLevel,
          '德语': langLevel,
          '英语': langLevel,
          '俄语': langLevel,
          '西班牙语': langLevel,
          '葡萄牙语': langLevel,
          '瑞典语': langLevel
        }
        const langKeys = Object.keys(lang)
        const keyVal = langValues[0]
        const key1DefaultIndex = _.findIndex(langKeys, function (item) {
          return item === keyVal
        })
        const key2DefaultIndex = _.findIndex(langLevel, function (item) {
          return item === langValues[1]
        })
        this.langColumns = [
          {
            values: langKeys,
            className: 'column1',
            defaultIndex: key1DefaultIndex
          },
          {
            values: lang[keyVal],
            className: 'column2',
            defaultIndex: key2DefaultIndex
          }
        ]
        this.popupLang = true
        return
      } else if (popType === 'inField') {
        this.columns = ['是', '否']
      } else if (popType === 'instructorLevel') {
        this.columns = ['一级', '二级']
      } else if (popType === 'refereeLevel') {
        this.columns = ['一级', '二级']
      } else if (popType === 'refereeCertificateDate') {
        this.PopupDate = true
        return
      } else if (popType === 'establishDate') {
        this.PopupDate = true
        return
      }
      this.show = true
    },
    onChange(picker, value, index) {},
    onConfirm(value, index) {
      this.info[this.popType] = value
      this.show = false
    },
    onCancel() {
      this.show = false
      this.schoolSearch = ''
    },
    dateConfirm(value) {
      let date = moment(value).format('YYYY-MM-DD')
      this.info[this.popType] = date
      this.PopupDate = false
    },
    dateCancel() {
      this.PopupDate = false
    },
    languageConfirm(value) {
      this.info[this.popType] = value.join('|')
      this.popupLang = false
    },
    languageCancel() {
      this.popupLang = false
    },
    onLangChange(picker, value, index) {
//      console.log(picker.getColumnValues(1))
//      console.log(picker.getColumnValues(0))
    },

    dateFormatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value
    },
    uploadCert(id) {
      const memberType = getMemberType()
      if (memberType.status === 2) {
        const info = {
          id: this.info.id,
          profile: this.info.profile,
          stickHand: this.info.stickHand,
          high: this.info.high,
          weight: this.info.weight,
          category: this.info.category,
          school: this.info.school,
          educationSummary: this.info.educationSummary,
          certificateFrontImg: this.info.certificateFrontImg,
          certificateBackImg: this.info.certificateBackImg,
          studentCardImg: this.info.studentCardImg,
          certificateImg: this.info.certificateImg,
          source: this.info.source,
          otherSource: this.info.otherSource

      }
        setRegisterInfo(info) // 暂存数据
      } else {
        setRegisterInfo(this.info) // 暂存数据
      }
      const isCenter = this.$route.query.isCenter || ''
      this.$router.push({ path: 'upload-file', query: {type: id, isCenter, reset: this.reset} })
    },
    mapPickerValues() {
      if (this.info.certificateType === 1) {
        this.info.certificateType = '身份证'
      } else if (this.info.certificateType === 2) {
        this.info.certificateType = '护照'
      } else {
        // this.info.certificateType = ''
      }
      if (this.info.birthday) {
        this.info.birthday = moment(this.info.birthday).format('YYYY-MM-DD')
      }
      if (this.info.birthDay) {
        this.info.birthday = moment(this.info.birthDay).format('YYYY-MM-DD')
      }
      if (this.info.abroadDate) {
        this.info.abroadDate = moment(this.info.birthDay).format('YYYY-MM-DD')
      }
      if (this.info.refereeCertificateDate) {
        this.info.refereeCertificateDate = moment(this.info.refereeCertificateDate).format('YYYY-MM-DD')
      }
      if (this.info.establishDate) {
        this.info.establishDate = moment(this.info.establishDate).format('YYYY-MM-DD')
      }
      if (this.type === 'in-referee') {
        this.info.inField = '是'
      } else if (this.type === 'out-referee') {
        this.info.inField = '否'
      }
      if (this.info.source) {
        if (!this.sourceList.includes(this.info.source)) {
          this.info.otherSource = this.info.source
          this.info.source = this.sourceList[3]
        }
      }
      this.getSchoolList()
    },
    getRegInfo() {
      if (this.type === 'player') {
        this.getRegPlayer()
      } else if (this.type === 'coach') {
        this.getRegCoach()
      } else if (this.type === 'in-referee') {
        this.getRegReferee(1)
      } else if (this.type === 'out-referee') {
        this.getRegReferee(0)
      } else if (this.type === 'member') {
        this.getRegOrganization()
      }
    },
    getMyInfo() {
      if (this.type === 'player') {
        this.getMyPlayer()
      } else if (this.type === 'coach') {
        this.getMyCoach()
      } else if (this.type === 'in-referee' || this.type === 'out-referee') {
        this.getMyReferee()
      } else if (this.type === 'member') {
        this.getMyOrganization()
      }
    },
    getRegPlayer() {
      getRegPlayer().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.player)
          this.info.source = data.membership && data.membership.source
          this.mapPickerValues()
        }
      })
    },
    getRegCoach() {
      getRegCoach().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.coach)
          this.info.source = data.membership && data.membership.source
          this.mapPickerValues()
        }
      })
    },
    getRegReferee() {
      const type = (this.type === 'in-referee') ? 1 : 0
      getRegReferee(type).then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.referee)
          this.info.source = data.membership && data.membership.source
          this.mapPickerValues()
        }
      })
    },
    getRegOrganization() {
      getRegOrganization().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.organization)
          this.info.source = data.membership && data.membership.source
          this.mapPickerValues()
        }
      })
    },
    getMyPlayer() {
      getMyPlayer().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.player.user, data.player)
          this.info.source = data.membership && data.membership.source
          this.mapPickerValues()
        }
      })
    },
    getMyCoach() {
      getMyCoach().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.coach.user, data.coach)
          this.info.source = data.membership && data.membership.source
          this.mapPickerValues()
        }
      })
    },
    getMyReferee() {
      getMyReferee().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.referee.user, data.referee)
          this.info.source = data.membership && data.membership.source
          this.mapPickerValues()
        }
      })
    },
    getMyOrganization() {
      getMyOrganization().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.organization.user, data.organization)
          this.info.source = data.membership && data.membership.source
          this.mapPickerValues()
        }
      })
    },
    updateInfo() {
      if (this.type === 'player') {
        this.updatePlayer()
      } else if (this.type === 'coach') {
        this.updateCoach()
      } else if (this.type === 'in-referee' || this.type === 'out-referee') {
        this.updateReferee()
      } else if (this.type === 'member') {
        this.updateOrganization()
      }
    },
    updatePlayer() {
      if (!this.info.profile) {
        Toast('请上传最新头像信息！')
        return
      }
      if (!this.info.category) {
        Toast('请填写身份类型信息！')
        return
      }
      if (this.info.category === '北京学生' && !(this.info.school.id && this.info.enterSchoolYear && this.info.studentCardImg)) {
        Toast('北京学生需要填写就读学校、学籍卡、入学年度信息！')
        return
      } else if (this.info.category === '外地学生') {
        if (!this.info.enterSchoolYear) {
          Toast('外地学生需要填写入学年度信息')
          return
        }
      }
      const params = {
        id: this.info.id,
        profile: this.info.profile,
        stickHand: this.info.stickHand,
        area: '北京-长期',
        high: this.info.high,
//        coachId: this.info.coach.id,
        weight: this.info.weight,
        category: this.info.category,
        schoolId: this.info.school.id,
        studentCardImg: this.info.studentCardImg,
        isAbroad: this.info.isAbroad,
        abroadDate: this.info.abroadDate,
        educationSummary: this.info.educationSummary
      }
      if (this.info.source === this.sourceList[3]) {
        params.source = this.info.otherSource
      } else {
        params.source = this.info.source
      }
      updatePlayer(params).then(response => {
        const data = response.data
        if (data) {
          Toast('保存成功')
          if (this.reset==1) {
            this.$router.push({path: 'hockey', query: {reset: 1}})
          } else {
            this.$router.push('ucenter')
          }
        }
      })
    },
    updateCoach() {
      const params = {
        id: this.info.id,
        profile: this.info.profile,
        area: '北京-长期',
        high: this.info.high,
        weight: this.info.weight,
        educationLevel: this.info.educationLevel,
        foreignLanguage: this.info.foreignLanguage
      }
      if (this.info.source === this.sourceList[3]) {
        params.source = this.info.otherSource
      } else {
        params.source = this.info.source
      }
      updateCoach(params).then(response => {
        const data = response.data
        if (data) {
          Toast('保存成功')
          if (this.reset==1) {
            this.$router.push({path: 'personal-experience', query: {reset: 1}})
          } else {
            this.$router.push('ucenter')
          }
        }
      })
    },
    updateReferee() {
      const params = {
        id: this.info.id,
        profile: this.info.profile,
        high: this.info.high,
        weight: this.info.weight,
        educationLevel: this.info.educationLevel,
        foreignLanguage: this.info.foreignLanguage,
        instructorLevel: this.info.instructorLevel,
        refereeLevel: this.info.refereeLevel,
        refereeCertificateNo: this.info.refereeCertificateNo,
        refereeCertificateDate: this.info.refereeCertificateDate,
        employerOrganization: this.info.employerOrganization,
        workplaceAddress: this.info.workplaceAddress,
      }
      if (this.info.source === this.sourceList[3]) {
        params.source = this.info.otherSource
      } else {
        params.source = this.info.source
      }
      updateReferee(params).then(response => {
        const data = response.data
        if (data) {
          Toast('保存成功')
          if (this.reset==1) {
            this.$router.push({path: 'personal-experience', query: {reset: 1}})
          } else {
            this.$router.push('ucenter')
          }
        }
      })
    },
    updateOrganization() {
      const params = {
        id: this.info.id,
        profile: this.info.profile,
        teams: this.info.teams,
        humanCount: this.info.humanCount,
        assertCount: this.info.assertCount,
        inComeCount: this.info.inComeCount
      }
      if (this.info.source === this.sourceList[3]) {
        params.source = this.info.otherSource
      } else {
        params.source = this.info.source
      }
      updateOrganization(params).then(response => {
        const data = response.data
        if (data) {
          Toast('保存成功')
          if (this.reset==1) {
            this.$router.push({ path: 'review', query: {reset: 2} })
          } else {
            this.$router.push('ucenter')
          }
        }
      })
    }
  }
}
</script>

<style>
  #info {
    background-color: white;
  }

  #info .uploader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  #info .uploader i {
    font-size: 45px;
    opacity: 0;
  }

  #info .avatar {
    font-size: 18px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    border-bottom: 1px solid #F2F2F2;
  }

  #info .avatar-img {
    border-radius: 50px;
    overflow: hidden;
    position: relative;
    width: 60px;
    height: 60px;
  }

  #info .avatar-img img {
    width: 60px;
    height: 60px;
  }

  #info .textarea {
    padding: 15px;
    width: calc(100% - 30px);
  }

  #info .textarea h5 {
    font-size: 16px;
    padding: 10px 0 20px 0;
    margin: 0;
  }

  #info .textarea textarea {
    border: 1px solid grey;
    width: calc(100% - 20px);
    border-radius: 10px;
    padding: 10px;
    font-size: 16px;
  }

  #info .submit {
    height:60px;
    background: #185494;
    border-radius:2px;
    border: none;
    margin-top: 30px;
    font-weight:400;
    color: white;
    font-size:20px;
  }

  #info .cell-list .van-cell {
    font-size: 16px;
    padding: 20px 15px;
    border-bottom: 1px solid #F2F2F2;
  }

  #info .cell-width .van-cell__title {
    max-width: 120px;
  }

  #info .van-cell--clickable .van-cell__value .van-radio {
    float: right;
    padding: 0 5px;
  }

  #info .van-cell--clickable .van-cell__value .van-radio .van-radio__label {
    margin-left: 5px;
  }

  #info .pointOut {
    padding: 0 15px;
    height: 40px;
    background-color: rgba(248,248,248,1);
    font-weight:400;
    color:rgba(129,129,129,1);
    line-height: 40px;
  }

  #info .main .van-cell:not(:last-child)::after,
  #info .main .van-radio-group .van-cell-group .van-cell:not(:last-child)::after {
    right: 0.4rem;
  }

  #info .main .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #info .main .van-hairline--top-bottom::after {
    border-width: 0;
  }

  #info .profile-loading {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: white;
  }

  #info .profile-loading .van-loading {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/personal-information.vue